import { render, staticRenderFns } from "./Hijo.vue?vue&type=template&id=a9b87b72&"
import script from "./Hijo.vue?vue&type=script&lang=js&"
export * from "./Hijo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports